import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import { Accomplishment } from "../../models/Accomplishment";
import { useStyles } from "../Main/formStyles";
import AccomplishmentCreateModal from "./AccomplishmentCreateModal";
import { Token } from "../../theme";
import { AccomplishmentType } from "../../models/AccomplishmentType";
import AutoCompleteUIDTO from "../../dto/AutoCompleteUIDTO";

interface Props {
  isEdit: boolean;
  setIsEdit: (value: boolean) => void;
  currentAccomplishment: Accomplishment | undefined;
  setCurrentAccomplishment: (value: Accomplishment | undefined) => void;
  handleOnUpdate: (instance: Accomplishment) => void;
  links: string[];
  setLinks: (value: string[]) => void;
  isLoading: boolean;
  accomplishmentTypes: AccomplishmentType[] | undefined;
  userAssignations: AutoCompleteUIDTO[] | undefined;
  getAccomplishmentData: (externalId: string) => AccomplishmentType | undefined;
}

export default function AccomplishmentEditFormModal({
  isEdit,
  setIsEdit,
  currentAccomplishment,
  setCurrentAccomplishment,
  handleOnUpdate,
  links,
  setLinks,
  isLoading,
  accomplishmentTypes,
  userAssignations,
  getAccomplishmentData,
}: Props) {
  const customStyles = useStyles();

  return (
    <GenericForm<Accomplishment>
      headerStyles={{ color: Token.textPrimary, marginBottom: -10, marginTop: 10 }}
      buttonStyles={{ marginRight: 20, color: "white", backgroundColor: Token.actionPrimary, marginBottom: 10 }}
      cancelButtonStyles={{
        color: Token.textSecondary,
        border: `1px solid ${Token.borderDefault}`,
        marginBottom: 10,
      }}
      dialogStyles={customStyles.root}
      dialog={true}
      open={!!isEdit}
      instance={currentAccomplishment}
      onSave={(instance) => {
        handleOnUpdate(instance);
      }}
      onCancel={() => {
        setIsEdit(false);
        setLinks([]);
        setCurrentAccomplishment(undefined);
      }}
      title={"Edit Accomplishment"}
      renderContent={(register, errors, control) => (
        <AccomplishmentCreateModal
          register={register}
          errors={errors}
          control={control}
          isLoading={isLoading}
          setLinks={setLinks}
          links={links}
          instance={currentAccomplishment!}
          accomplishmentTypes={accomplishmentTypes}
          userAssignations={userAssignations}
          getAccomplishmentData={getAccomplishmentData}
        />
      )}
    />
  );
}
